import * as Communicator from "@ts3d-hoops/web-viewer";

/** Ghost draw mode - custom value, removed from HOOPS SDK in v2025.8.0 */
export const GhostDrawMode = 10001 as Communicator.DrawMode;

export type Callback3DViewerKey = keyof Partial<Communicator.CallbackMap>;
export type StateOnChange = "hand" | "select-text-image" | "marquee";
export const mapStateOperatorPdf: Record<StateOnChange, OperatorType> = {
    hand: "pan",
    "select-text-image": "select",
    marquee: "zoomWindow",
};
export type OperatorType = "" | Operator3DType | OperatorPdfType;
type OperatorCommon =
    | "home"
    | "select"
    | "pan"
    | "zoomIn"
    | "zoomOut"
    | "zoomWindow"
    | "zoomFit"
    | "save"
    | "setting"
    | "rotateZ"
    | "clipping-commands"
    | "propertyPanel"
    | "lineSetting"
    | "formatSetting"
    | "modelTree"
    | "linkedObjects"
    | "synchronized"
    | "statesObjects"
    | "lightStates";
type Op3D =
    | "orbit"
    | "walkThrough"
    | "drawMode-wireframe"
    | "drawMode-hidden-line"
    | "drawMode-shaded-wire"
    | "drawMode-xray"
    | "drawMode-shaded"
    | "drawMode-ghosting"
    | "cutting-plane"
    | "areaSelect"
    | "explode"
    | "model-tree";
type OpPdf =
    | "plan-mode"
    | "document-mode"
    | "next-page"
    | "previous-page"
    | "first-page"
    | "last-page"
    | "current-page";
export type Operator3DType = OperatorCommon | Op3D;
export type OperatorPdfType = OperatorCommon | OpPdf;

export type CuttingType =
    | "close"
    | "multi"
    | "toggle-section"
    | "toggle-plane"
    | "plane-x"
    | "plane-y"
    | "plane-z"
    | "plane-box"
    | "rotate-box"
    | "reverse-plane-x"
    | "reverse-plane-y"
    | "reverse-plane-z";

export type Context3DType =
    | "zoom-fit"
    | "zoom-selected"
    | "isolate"
    | "hide"
    | "show-all"
    | "reset"
    | "show-handles"
    | "save-view"
    | "copy"
    | "paste"
    | "annotate"
    | "pinDOCS"
    | "pinSUB"
    | "pinRFI"
    | "pinPCI"
    | "preset-view"
    | "Top"
    | "Bottom"
    | "Left"
    | "Right"
    | "Front"
    | "Back"
    | "Iso"
    | "link-property"
    | "states-objects"
    | "light-states";

export type ContextPdfType = "zoom-fit" | "zoom-selected" | "save-view";

export type PlaneBoxChild =
    | "plane-x-plus"
    | "plane-y-plus"
    | "plane-z-plus"
    | "plane-x-minus"
    | "plane-y-minus"
    | "plane-z-minus";

export interface IsolateInfo {
    nodeIds: NodeId[];
    drawMode: Communicator.DrawMode;
}
